/* The Katha: fabric night bar (kh-night section).
   Drag the bar: the fabric that suits that night best is marked. Every fabric keeps its own "best for" line; none is hidden. */
(function () {
  if (window.khNight) return; window.khNight = 1;

  function init(root) {
    if (root.kn) return; root.kn = 1;
    var range = root.querySelector('[data-kn-range]'); if (!range) return;
    var rows = [].slice.call(root.querySelectorAll('[data-kn-row]'));

    /* how far a night is from a fabric's sweet spot: outside it counts ten times more than off-centre inside it */
    function far(row, p) {
      var a = +row.dataset.a, b = +row.dataset.b;
      return (p < a ? a - p : p > b ? p - b : 0) * 10 + Math.abs(p - (a + b) / 2);
    }
    range.addEventListener('input', function () {
      var p = +range.value, best = null;
      root.style.setProperty('--p', p / 100);
      rows.forEach(function (r) { if (!best || far(r, p) < far(best, p)) best = r; });
      rows.forEach(function (r) {
        var lab = r.querySelector('[data-kn-lab]'), on = r === best;
        r.classList.toggle('is-best', on);
        if (lab) lab.textContent = on ? root.dataset.best : lab.dataset.std;
      });
    });
  }

  function all() { [].forEach.call(document.querySelectorAll('[data-kn]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
